import { useEffect, useState } from 'react';
import { procurementApi } from '@/api/procurement.api';
import { PageHeader } from '@/components/layout/PageHeader';
import { useSupplierOptions } from '@/hooks/useSupplierOptions';
import { showApiError } from '@/utils/apiError';

export function CatalogPage() {
  const { getLabel: getSupplierLabel } = useSupplierOptions();
  const [items, setItems] = useState<Awaited<ReturnType<typeof procurementApi.listCatalogs>>>([]);

  useEffect(() => {
    procurementApi.listCatalogs(true).then(setItems).catch((e) => showApiError(e, 'Failed to load catalogs'));
  }, []);

  return (
    <div>
      <PageHeader
        title="Supplier catalogs"
        description="Published supplier catalogs for direct buying"
        breadcrumbs={[{ label: 'Procurement', to: '/procurement' }, { label: 'Catalogs' }]}
      />
      <div className="grid gap-3 sm:grid-cols-2">
        {items.length === 0 ? (
          <p className="text-sm text-slate-500">No published catalogs.</p>
        ) : (
          items.map((c) => (
            <div key={c.id} className="card p-4">
              <p className="font-semibold">{c.catalogName}</p>
              <p className="mt-1 text-sm text-slate-500">
                {getSupplierLabel(c.supplierId, true)} · {c.catalogStatus}
              </p>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
